import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

import './sporsmal-header.scss';

interface Props {
    tittel: string;
    ingress?: string;
    extraWide?: boolean;
}

export const SporsmalHeader: React.FC<PropsWithChildren<Props>> = ({
    children,
    tittel,
    ingress,
    extraWide = false,
}) => (
    <fieldset
        className={classNames(
            'step-wrapper',
            extraWide ? 'container__large-width' : 'container__standard-width step-wrapper',
        )}
    >
        <legend>
            <span className={classNames('step-header', { 'step-header__with-ingress': !!ingress })}>{tittel}</span>
            {ingress && <span className="step-ingress">{ingress}</span>}
        </legend>
        {children}
    </fieldset>
);
